export const isColumnToHide = columnLabel => {
  const columnsToHideSetting = `${
    window.GPAC_ENV?.SENDOUT_DASHBOARD_COLUMNS_HIDE ||
    process.env.REACT_APP_SENDOUT_DASHBOARD_COLUMNS_HIDE
  }`;
  const columnsToHide = columnsToHideSetting ? columnsToHideSetting.split(',') : [];
  return columnsToHide.includes(columnLabel);
};
